var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoBanner3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C12 3.44772 12.4477 3 13 3H28.1716C28.4368 3 28.6911 3.10536 28.8787 3.29289L35.7071 10.1213C35.8946 10.3089 36 10.5632 36 10.8284V34C36 34.5523 35.5523 35 35 35H13C12.4477 35 12 34.5523 12 34V4Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 3V9C28 10.1046 28.8954 11 30 11H36",
    stroke: "white",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 41,
    width: 8,
    height: 4,
    rx: 1,
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 35,
    width: 2,
    height: 6,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 42C0.447715 42 0 42.4477 0 43C0 43.5523 0.447715 44 1 44H19V42H1ZM47 42C47.5523 42 48 42.4477 48 43C48 43.5523 47.5523 44 47 44H29V42H47Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19C17 18.4477 17.4477 18 18 18H30C30.5523 18 31 18.4477 31 19C31 19.5523 30.5523 20 30 20H18C17.4477 20 17 19.5523 17 19Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24C17 23.4477 17.4477 23 18 23H30C30.5523 23 31 23.4477 31 24C31 24.5523 30.5523 25 30 25H18C17.4477 25 17 24.5523 17 24Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 29C17 28.4477 17.4477 28 18 28H30C30.5523 28 31 28.4477 31 29C31 29.5523 30.5523 30 30 30H18C17.4477 30 17 29.5523 17 29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBanner3);
export default __webpack_public_path__ + "static/media/info-banner-3.eb8062d47dc6c4d202b0cea76637a755.svg";
export { ForwardRef as ReactComponent };